"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.piecesWithoutCreations = exports.piecesList = exports.getVariousPricingsItemsForCreation = exports.getVariousPricingsCategory = exports.getPricingsItemsWithIds = exports.getFilteredVariousPricingsItems = exports.getEmbroideryPricingsCategory = exports.getCommunZips = exports.getCommunTear = exports.getCommunMachineEmbroidery = exports.getCommunButtons = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *** Version: 12 ***

/* eslint max-len: 0, object-curly-newline: 0 */

var version = 12;
var piecesList = exports.piecesList = ['pant', 'haut', 'robe', 'mari', 'mant', 'jupe', 'pull', 'comb', 'ling', 'acce', 'deco', 'crea_tote', 'crea_sac', 'crea_poch', 'crea_hous', 'crea_assi', 'crea_doss', 'crea_cana', 'crea_plai', 'crea_chai', 'crea_stoo', 'crea_ride'];
var piecesWithoutCreations = exports.piecesWithoutCreations = piecesList.filter(function (piece) {
  return !piece.startsWith('crea_');
});
var SMALL_ZIP = 'Zip court (< 25cm) fourni par le Tilliste : réparation / remplacement';
var TEAR = 'Déchirure : réparation';
var SIMPLE_EXTRA_SEAM = 'Couture d’appoint / décousu - simple';
var PARTIAL_LINING = 'Doublure : changement partiel';
var BUTTON = 'Bouton (x1) fourni par le Tilliste : ajout / remplacement';
var HOLE = 'Trou : raccommodage simple';
var ELBOW = 'Coudières (x2) : ajout / remplacement';
var BUTTONHOLE = 'Boutonnière (x1) : création';
var ELASTIC = 'Élastique : ajout';
var HOOK = 'Crochets  (x1) : ajout / remplacement';
var mostCommonCategoryPositions = {
  mant: [{
    name: PARTIAL_LINING,
    position: 3
  }, {
    name: SMALL_ZIP,
    position: 4
  }, {
    name: TEAR,
    position: 5
  }],
  haut: [{
    name: BUTTON,
    position: 1
  }, {
    name: TEAR,
    position: 2
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 3
  }],
  pant: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  jupe: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  robe: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  pull: [{
    name: HOLE,
    position: 1
  }, {
    name: ELBOW,
    position: 2
  }, {
    name: BUTTONHOLE,
    position: 3
  }, {
    name: BUTTON,
    position: 4
  }],
  ling: [{
    name: TEAR,
    position: 1
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 2
  }, {
    name: ELASTIC,
    position: 3
  }],
  comb: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }],
  mari: [{
    name: SMALL_ZIP,
    position: 2
  }, {
    name: TEAR,
    position: 3
  }, {
    name: SIMPLE_EXTRA_SEAM,
    position: 4
  }]
};
var getPricingsItemsWithIds = exports.getPricingsItemsWithIds = function getPricingsItemsWithIds(items, categorySlug, slug, type) {
  var minIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var isSuitableForJunior = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  return items.map(function (pricing, index) {
    var _mostCommonCategoryPo;
    var newIndex = minIndex + index + 1;
    var name = pricing.name,
      prices = pricing.prices,
      liningPrices = pricing.liningPrices,
      multiple = pricing.multiple,
      itemPosition = pricing.itemPosition,
      hidden = pricing.hidden,
      repairBonus = pricing.repairBonus;
    var updatedPrices = type ? {
      DEFAULT: prices[type]
    } : _objectSpread({}, prices);
    delete updatedPrices.mari;
    var updatedLiningPrices;
    if (type) {
      if (liningPrices !== null && liningPrices !== void 0 && liningPrices[type]) updatedLiningPrices = liningPrices !== null && liningPrices !== void 0 && liningPrices[type] ? {
        DEFAULT: liningPrices[type]
      } : undefined;
    } else {
      updatedLiningPrices = _objectSpread({}, liningPrices);
    }
    if (updatedLiningPrices) delete updatedLiningPrices.mari;
    if (updatedLiningPrices && Object.keys(updatedLiningPrices).length === 0) updatedLiningPrices = undefined;
    var item = {
      name: name,
      prices: updatedPrices,
      id: "".concat(version, ".").concat(slug, "-").concat(categorySlug, "-").concat(newIndex),
      itemPosition: itemPosition
    };
    if (isSuitableForJunior) item.isSuitableForJunior = isSuitableForJunior;
    if (updatedLiningPrices) item.liningPrices = updatedLiningPrices;
    if (multiple) item.multiple = multiple;
    if (hidden) item.hidden = hidden;
    if (repairBonus) item.repairBonus = repairBonus;
    if ((_mostCommonCategoryPo = mostCommonCategoryPositions[slug]) !== null && _mostCommonCategoryPo !== void 0 && _mostCommonCategoryPo.find(function (mostCommon) {
      return mostCommon.name === name;
    })) {
      item.mostCommonCategoryPosition = mostCommonCategoryPositions[slug].find(function (mostCommon) {
        return mostCommon.name === name;
      }).position;
    }
    return item;
  }).sort(function (itemA, itemB) {
    return itemA.itemPosition - itemB.itemPosition;
  });
};
var embroideryPricingsItems = [{
  itemPosition: 1,
  name: 'Initiales',
  prices: {
    SIMPLE: 10,
    COMPLEX: 10,
    mari: 20
  },
  multiple: true
}, {
  itemPosition: 2,
  name: 'Un mot (10 lettres - petite police)',
  prices: {
    SIMPLE: 15,
    COMPLEX: 15,
    mari: 28
  },
  multiple: true
}, {
  itemPosition: 3,
  name: 'Un mot (10 lettres - grosse police)',
  prices: {
    SIMPLE: 45,
    COMPLEX: 45,
    mari: 52
  },
  multiple: true
}, {
  itemPosition: 4,
  name: 'Un mot (10 lettres - grosse police pleine)',
  prices: {
    SIMPLE: 80,
    COMPLEX: 80,
    mari: 110
  },
  multiple: true
}, {
  itemPosition: 5,
  name: 'Dessin creux forme simple < 5cm',
  prices: {
    SIMPLE: 10,
    COMPLEX: 10,
    mari: 18
  },
  multiple: true
}, {
  itemPosition: 6,
  name: 'Dessin creux forme simple < 12cm',
  prices: {
    SIMPLE: 17,
    COMPLEX: 17,
    mari: 25
  },
  multiple: true
}, {
  itemPosition: 7,
  name: 'Dessin creux forme simple < 25cm',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25,
    mari: 35
  },
  multiple: true
}, {
  itemPosition: 8,
  name: 'Dessin plein forme simple < 5cm',
  prices: {
    SIMPLE: 35,
    COMPLEX: 35,
    mari: 48
  },
  multiple: true
}, {
  itemPosition: 9,
  name: 'Dessin plein complexe < 5cm',
  prices: {
    SIMPLE: 65,
    COMPLEX: 65,
    mari: 80
  },
  multiple: true
}, {
  itemPosition: 10,
  name: 'Dessin plein forme simple < 12cm',
  prices: {
    SIMPLE: 55,
    COMPLEX: 55,
    mari: 71
  },
  multiple: true
}, {
  itemPosition: 11,
  name: 'Dessin plein complexe < 12cm',
  prices: {
    SIMPLE: 130,
    COMPLEX: 130,
    mari: 200
  },
  multiple: true
}, {
  itemPosition: 12,
  name: 'Dessin creux complexe < 5cm',
  prices: {
    SIMPLE: 15,
    COMPLEX: 15,
    mari: 25
  },
  multiple: true
}, {
  itemPosition: 13,
  name: 'Dessin creux complexe < 12cm',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25,
    mari: 35
  },
  multiple: true
}, {
  itemPosition: 14,
  name: 'Dessin creux complexe < 25cm',
  prices: {
    SIMPLE: 40,
    COMPLEX: 40,
    mari: 45
  },
  multiple: true
}];
var getCommunMachineEmbroidery = exports.getCommunMachineEmbroidery = function getCommunMachineEmbroidery(_ref) {
  var slug = _ref.slug;
  return {
    name: 'Broderie machine',
    slug: 'machine_embroidery',
    items: [{
      name: 'Texte (15 lettres maximum) ≤ 0.5cm',
      prices: slug === 'deco' ? {
        DEFAULT: 12
      } : {
        SIMPLE: 12,
        COMPLEX: 12
      },
      id: "12.".concat(slug, "-bro-15"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 2cm',
      prices: slug === 'deco' ? {
        DEFAULT: 15
      } : {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: "12.".concat(slug, "-bro-16"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Texte (15 lettres maximum) ≤ 3cm',
      prices: slug === 'deco' ? {
        DEFAULT: 20
      } : {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "12.".concat(slug, "-bro-17"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 0.5cm',
      prices: slug === 'deco' ? {
        DEFAULT: 12
      } : {
        SIMPLE: 12,
        COMPLEX: 12
      },
      id: "12.".concat(slug, "-bro-18"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 2cm',
      prices: slug === 'deco' ? {
        DEFAULT: 15
      } : {
        SIMPLE: 15,
        COMPLEX: 15
      },
      id: "12.".concat(slug, "-bro-19"),
      multiple: true,
      isSuitableForJunior: true
    }, {
      name: 'Dessin creux ≤ 3cm',
      prices: slug === 'deco' ? {
        DEFAULT: 20
      } : {
        SIMPLE: 20,
        COMPLEX: 20
      },
      id: "12.".concat(slug, "-bro-20"),
      multiple: true,
      isSuitableForJunior: true
    }]
  };
};
var getEmbroideryPricingsCategory = exports.getEmbroideryPricingsCategory = function getEmbroideryPricingsCategory(slug, type) {
  return {
    name: 'Broderie main',
    slug: 'hand_embroidery',
    items: getPricingsItemsWithIds(embroideryPricingsItems, 'bro', slug, type)
  };
};

// all in "hidden: true" because they are duplicates but we need to keep ids, do not add items here
var variousPricingsItems = [{
  itemPosition: 1,
  name: 'Bretelles (x2) : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 12,
    COMPLEX: 18,
    mari: 45
  },
  pieces: ['haut', 'robe', 'jupe', 'mari', 'comb', 'ling'],
  hidden: true
}, {
  itemPosition: 2,
  name: 'Épaulettes (x2) : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 18,
    COMPLEX: 21,
    mari: 35
  },
  liningPrices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 8
  },
  pieces: ['mant', 'haut', 'robe', 'pull', 'comb', 'mari'],
  hidden: true
}, {
  itemPosition: 3,
  name: ELBOW,
  prices: {
    SIMPLE: 17,
    COMPLEX: 20
  },
  pieces: ['haut', 'pull', 'comb', 'mant'],
  hidden: true
}, {
  itemPosition: 4,
  name: 'Attache dos : remplacement',
  prices: {
    SIMPLE: 10,
    COMPLEX: 15
  },
  multiple: true,
  pieces: ['ling'],
  hidden: true
}, {
  itemPosition: 5,
  name: 'Baleines (x2) : remplacement / réparation',
  prices: {
    SIMPLE: 12,
    COMPLEX: 17
  },
  liningPrices: {
    SIMPLE: 8,
    COMPLEX: 17
  },
  multiple: true,
  pieces: ['ling'],
  hidden: true
}, {
  itemPosition: 6,
  name: 'Ceinture : ajout / remplacement',
  prices: {
    mari: 42
  },
  multiple: true,
  pieces: ['mari'],
  hidden: true
}, {
  itemPosition: 7,
  name: 'Passant (x1) : ajout / remplacement',
  prices: {
    SIMPLE: 4,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 8,
  name: 'Genouillères (x2) : ajout / remplacement',
  prices: {
    SIMPLE: 17,
    COMPLEX: 20
  },
  pieces: ['pant', 'comb'],
  hidden: true
}, {
  itemPosition: 9,
  name: 'Pince (x1) : ajout',
  prices: {
    SIMPLE: 8,
    COMPLEX: 12,
    mari: 25
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 5
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 10,
  name: 'Fente : ajout / retrait',
  prices: {
    SIMPLE: 12,
    COMPLEX: 18,
    mari: 29
  },
  liningPrices: {
    SIMPLE: 4,
    COMPLEX: 6,
    mari: 6
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 11,
  name: ELASTIC,
  prices: {
    SIMPLE: 7,
    COMPLEX: 17,
    mari: 22
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 3
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 12,
  name: 'Perlage (5 à 10 perles)',
  prices: {
    SIMPLE: 15,
    COMPLEX: 17,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 13,
  name: 'Doublure : changement intégral',
  prices: {
    COMPLEX: 105
  },
  pieces: ['mant'],
  repairBonus: 'LINING_COMPLEX',
  hidden: true
}, {
  itemPosition: 14,
  name: PARTIAL_LINING,
  prices: {
    COMPLEX: 45
  },
  pieces: ['mant'],
  repairBonus: 'LINING_COMPLEX',
  hidden: true
}, {
  itemPosition: 15,
  name: 'Doublure : ajout / remplacement',
  prices: {
    SIMPLE: 35,
    COMPLEX: 55,
    mari: 69
  },
  pieces: piecesWithoutCreations.filter(function (piece) {
    return !['mant', 'robe', 'pant', 'jupe'].includes(piece);
  }),
  repairBonus: {
    SIMPLE: 'LINING_SIMPLE',
    COMPLEX: 'LINING_COMPLEX',
    mari: 'LINING_COMPLEX'
  },
  hidden: true
}, {
  itemPosition: 15.5,
  name: 'Doublure : ajout / remplacement',
  prices: {
    SIMPLE: 42,
    COMPLEX: 49
  },
  pieces: ['robe', 'pant', 'jupe'],
  repairBonus: 'LINING_SIMPLE',
  hidden: true
}, {
  itemPosition: 16,
  name: 'Poche (x1) : changement de doublure',
  prices: {
    SIMPLE: 17,
    COMPLEX: 19,
    mari: 21
  },
  multiple: true,
  pieces: piecesWithoutCreations,
  repairBonus: 'LINING_SIMPLE',
  hidden: true
}, {
  itemPosition: 17,
  name: 'Poche plate simple (x1) : ajout',
  prices: {
    SIMPLE: 10,
    COMPLEX: 15,
    mari: 18
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 18,
  name: 'Poche intérieure classique (x1) : ajout',
  prices: {
    SIMPLE: 15,
    COMPLEX: 19,
    mari: 22
  },
  multiple: true,
  pieces: piecesWithoutCreations,
  hidden: true
}, {
  itemPosition: 19,
  name: 'Poche complexe (x1) : ajout',
  prices: {
    SIMPLE: 20,
    COMPLEX: 22,
    mari: 27
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 20,
  name: BUTTONHOLE,
  prices: {
    SIMPLE: 3,
    COMPLEX: 4,
    mari: 10
  },
  liningPrices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 21,
  name: BUTTON,
  prices: {
    SIMPLE: 3,
    COMPLEX: 3,
    mari: 4
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23,
  name: 'Bouton pression (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 6,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 22,
  name: 'Bouton (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 24,
  name: SMALL_ZIP,
  prices: {
    SIMPLE: 22,
    COMPLEX: 24,
    mari: 30
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 25,
  name: 'Zip long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 45,
    COMPLEX: 47,
    mari: 62
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 26,
  name: 'Zip invisible court (< 25cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 26,
    COMPLEX: 26,
    mari: 56
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 27,
  name: 'Zip invisible long (40-80cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 53,
    COMPLEX: 53,
    mari: 63
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 15
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 32,
  name: TEAR,
  prices: {
    SIMPLE: 12,
    COMPLEX: 16,
    mari: 21
  },
  liningPrices: {
    mari: 8
  },
  repairBonus: 'HOLE',
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 33,
  name: HOLE,
  prices: {
    SIMPLE: 12,
    COMPLEX: 12
  },
  multiple: true,
  pieces: ['mant', 'pull'],
  repairBonus: 'UNTIED_UNLINED',
  hidden: true
}, {
  itemPosition: 34,
  name: 'Trou : raccommodage (> 10 trous)',
  prices: {
    SIMPLE: 6,
    COMPLEX: 6
  },
  multiple: true,
  pieces: ['mant', 'pull'],
  hidden: true
}, {
  itemPosition: 35,
  name: SIMPLE_EXTRA_SEAM,
  prices: {
    SIMPLE: 12,
    COMPLEX: 14,
    mari: 17
  },
  repairBonus: 'UNTIED_UNLINED',
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 36,
  name: 'Couture d’appoint / décousu - complexe',
  prices: {
    SIMPLE: 14,
    COMPLEX: 16,
    mari: 19
  },
  repairBonus: 'UNTIED_LINED',
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 37,
  name: 'Couture complexe avec empiècement',
  prices: {
    SIMPLE: 15,
    COMPLEX: 17,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 39,
  name: 'Upcycling sur-mesure',
  prices: {
    SIMPLE: 30,
    COMPLEX: 35,
    mari: 35
  },
  multiple: true,
  pieces: piecesList,
  categories: ['upc']
}, {
  itemPosition: 28,
  name: 'Zip court (< 25cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 19,
    COMPLEX: 19,
    mari: 47
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 29,
  name: 'Zip long (40-80cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 40,
    COMPLEX: 40,
    mari: 53
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 30,
  name: 'Zip invisible court (< 25cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 23,
    COMPLEX: 23,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 12
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_SMALL'
}, {
  itemPosition: 31,
  name: 'Zip invisible long (40-80cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 48,
    COMPLEX: 48,
    mari: 50
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 15
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true,
  repairBonus: 'ZIP_BIG'
}, {
  itemPosition: 40,
  name: 'Scratch < 30cm',
  prices: {
    SIMPLE: 5,
    COMPLEX: 9
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 41,
  name: 'Scratch > 30cm',
  prices: {
    SIMPLE: 7,
    COMPLEX: 11
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 38,
  name: 'Couture complexe - 2 empiècements identiques (fourni par client)',
  prices: {
    SIMPLE: 25,
    COMPLEX: 25
  },
  multiple: true,
  pieces: piecesList.filter(function (piece) {
    return !['mari'].includes(piece);
  }),
  hidden: true
}, {
  itemPosition: 42,
  name: 'Oeillet petit (x1) : ajout',
  prices: {
    SIMPLE: 1,
    COMPLEX: 1,
    mari: 2
  },
  multiple: true,
  pieces: ['mari', 'ling', 'haut', 'robe', 'jupe', 'pull', 'comb', 'acce'],
  hidden: true
}, {
  itemPosition: 43,
  name: 'Oeillet petit (x1) : ajout',
  prices: {
    COMPLEX: 2
  },
  multiple: true,
  pieces: ['mant'],
  hidden: true
}, {
  itemPosition: 44,
  name: 'Oeillet moyen (x1) : ajout',
  prices: {
    SIMPLE: 4,
    COMPLEX: 4
  },
  multiple: true,
  pieces: ['acce', 'ride'],
  hidden: true
}, {
  itemPosition: 45,
  name: HOOK,
  prices: {
    SIMPLE: 6,
    COMPLEX: 8,
    mari: 10
  },
  multiple: true,
  pieces: ['pant', 'haut', 'robe', 'mari', 'jupe', 'mant', 'pull', 'ling'],
  hidden: true
}, {
  itemPosition: 21.4,
  name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
  prices: {
    SIMPLE: 3,
    COMPLEX: 3,
    mari: 3
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23.2,
  name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 2,
    COMPLEX: 2,
    mari: 2
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 21.7,
  name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
  prices: {
    SIMPLE: 8,
    COMPLEX: 8,
    mari: 8
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 23.5,
  name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
  prices: {
    SIMPLE: 6,
    COMPLEX: 6,
    mari: 6
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 24.5,
  name: 'Zip moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 35,
    COMPLEX: 37,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 26.5,
  name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 46,
    COMPLEX: 46,
    mari: 60
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 28.5,
  name: 'Zip moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 35,
    COMPLEX: 37,
    mari: 43
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 30.5,
  name: 'Zip invisible moyen (25-40cm) fourni par le client : ajout / remplacement / retrait',
  prices: {
    SIMPLE: 42,
    COMPLEX: 42,
    mari: 47
  },
  liningPrices: {
    SIMPLE: 5,
    COMPLEX: 5,
    mari: 13
  },
  multiple: true,
  pieces: piecesList,
  isClosing: true,
  hidden: true
}, {
  itemPosition: 46,
  name: 'Ourlet - décousu (x1 jambe)',
  prices: {
    SIMPLE: 5,
    COMPLEX: 5
  },
  pieces: ['pant', 'comb'],
  hidden: true
}, {
  itemPosition: 47,
  name: 'Ourlet - décousu (x2 jambes)',
  prices: {
    SIMPLE: 12,
    COMPLEX: 14
  },
  pieces: ['pant', 'comb'],
  repairBonus: 'UNTIED_UNLINED',
  hidden: true
}, {
  itemPosition: 48,
  name: 'Ourlet - décousu',
  prices: {
    mari: 25
  },
  liningPrices: {
    mari: 13
  },
  pieces: ['mari'],
  repairBonus: 'UNTIED_LINED',
  hidden: true
}, {
  itemPosition: 49,
  name: 'Ourlet - décousu',
  prices: {
    SIMPLE: 12,
    COMPLEX: 20
  },
  pieces: ['robe', 'jupe'],
  repairBonus: 'UNTIED_UNLINED',
  hidden: true
}, {
  itemPosition: 35.5,
  name: 'Petit trou / raccommodage',
  prices: {
    SIMPLE: 4,
    COMPLEX: 4,
    mari: 4
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}, {
  itemPosition: 32.5,
  name: 'Couture de finition',
  prices: {
    SIMPLE: 4,
    COMPLEX: 4,
    mari: 4
  },
  multiple: true,
  pieces: piecesList,
  hidden: true
}];
var getCommunTear = exports.getCommunTear = function getCommunTear(_ref2) {
  var slug = _ref2.slug,
    _ref2$isSuitableForJu = _ref2.isSuitableForJunior,
    isSuitableForJunior = _ref2$isSuitableForJu === void 0 ? false : _ref2$isSuitableForJu;
  var items = [{
    name: TEAR,
    prices: {
      SIMPLE: 12,
      COMPLEX: 16
    },
    id: "12.".concat(slug, "-rep-tear-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'HOLE'
  }, {
    name: 'Couture complexe avec empiècement',
    prices: {
      SIMPLE: 15,
      COMPLEX: 17
    },
    repairBonus: 'HOLE',
    id: "12.".concat(slug, "-rep-tear-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo2;
    var mostCommonCat = (_mostCommonCategoryPo2 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo2 === void 0 ? void 0 : _mostCommonCategoryPo2.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Déchirures / trous',
    slug: 'tear_repair',
    items: items
  };
};
var getCommunZips = exports.getCommunZips = function getCommunZips(_ref3) {
  var slug = _ref3.slug,
    _ref3$isSuitableForJu = _ref3.isSuitableForJunior,
    isSuitableForJunior = _ref3$isSuitableForJu === void 0 ? false : _ref3$isSuitableForJu;
  var items = [{
    name: SMALL_ZIP,
    prices: {
      SIMPLE: 22,
      COMPLEX: 24
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 35,
      COMPLEX: 37
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip long (40-80cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 45,
      COMPLEX: 47
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-3"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible court (< 25cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 26,
      COMPLEX: 28
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-4"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip invisible long (40-80cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 53,
      COMPLEX: 55
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-5"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip court (< 25cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 19,
      COMPLEX: 19
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-6"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip long (40-80cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 40,
      COMPLEX: 40
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-7"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible court (< 25cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 23,
      COMPLEX: 23
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-8"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_SMALL'
  }, {
    name: 'Zip invisible long (40-80cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 48,
      COMPLEX: 48
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-9"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible moyen (25-40cm) fourni par le Tilliste : réparation / remplacement',
    prices: {
      SIMPLE: 46,
      COMPLEX: 48
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-10"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip moyen (25-40cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 35,
      COMPLEX: 35
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-11"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }, {
    name: 'Zip invisible moyen (25-40cm) fourni par le client : réparation / remplacement',
    prices: {
      SIMPLE: 42,
      COMPLEX: 42
    },
    liningPrices: {
      SIMPLE: 5,
      COMPLEX: 5
    },
    id: "12.".concat(slug, "-rep-zip-12"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior,
    repairBonus: 'ZIP_BIG'
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo3;
    var mostCommonCat = (_mostCommonCategoryPo3 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo3 === void 0 ? void 0 : _mostCommonCategoryPo3.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Zips',
    slug: 'zip_repair',
    items: items
  };
};
var getCommunButtons = exports.getCommunButtons = function getCommunButtons(_ref4) {
  var slug = _ref4.slug,
    _ref4$isSuitableForJu = _ref4.isSuitableForJunior,
    isSuitableForJunior = _ref4$isSuitableForJu === void 0 ? false : _ref4$isSuitableForJu;
  var items = [{
    name: BUTTONHOLE,
    prices: {
      SIMPLE: 3,
      COMPLEX: 4
    },
    liningPrices: {
      SIMPLE: 1,
      COMPLEX: 1
    },
    id: "12.".concat(slug, "-rep-but-1"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: BUTTON,
    prices: {
      SIMPLE: 3,
      COMPLEX: 3
    },
    id: "12.".concat(slug, "-rep-but-2"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    id: "12.".concat(slug, "-rep-but-4"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à coudre (x1) fourni par le Tilliste : ajout / remplacement',
    prices: {
      SIMPLE: 3,
      COMPLEX: 3
    },
    id: "12.".concat(slug, "-rep-but-5"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à coudre (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 2,
      COMPLEX: 2
    },
    id: "12.".concat(slug, "-rep-but-6"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à poser (x1) fourni par le Tilliste : ajout / remplacement',
    prices: {
      SIMPLE: 8,
      COMPLEX: 8
    },
    id: "12.".concat(slug, "-rep-but-7"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }, {
    name: 'Bouton pression à poser (x1) fourni par le client : ajout / remplacement',
    prices: {
      SIMPLE: 6,
      COMPLEX: 6
    },
    id: "12.".concat(slug, "-rep-but-8"),
    multiple: true,
    isSuitableForJunior: isSuitableForJunior
  }];
  items.forEach(function (item) {
    var _mostCommonCategoryPo4;
    var mostCommonCat = (_mostCommonCategoryPo4 = mostCommonCategoryPositions[slug]) === null || _mostCommonCategoryPo4 === void 0 ? void 0 : _mostCommonCategoryPo4.find(function (mostCommon) {
      return mostCommon.name === item.name;
    });
    if (mostCommonCat) {
      item.mostCommonCategoryPosition = mostCommonCat.position;
    }
  });
  return {
    name: 'Boutons',
    slug: 'but_repair',
    items: items
  };
};
var getFilteredVariousPricingsItems = exports.getFilteredVariousPricingsItems = function getFilteredVariousPricingsItems(slug, category) {
  return variousPricingsItems.filter(function (_ref5) {
    var pieces = _ref5.pieces,
      categories = _ref5.categories;
    return pieces.includes(slug) && (!categories || categories.includes(category));
  });
};
var getVariousPricingsCategory = exports.getVariousPricingsCategory = function getVariousPricingsCategory(_ref6) {
  var pieceSlug = _ref6.pieceSlug,
    _ref6$name = _ref6.name,
    name = _ref6$name === void 0 ? 'Divers' : _ref6$name,
    _ref6$type = _ref6.type,
    type = _ref6$type === void 0 ? undefined : _ref6$type,
    _ref6$categorySlug = _ref6.categorySlug,
    categorySlug = _ref6$categorySlug === void 0 ? 'div' : _ref6$categorySlug,
    _ref6$minIndex = _ref6.minIndex,
    minIndex = _ref6$minIndex === void 0 ? 0 : _ref6$minIndex,
    _ref6$isSuitableForJu = _ref6.isSuitableForJunior,
    isSuitableForJunior = _ref6$isSuitableForJu === void 0 ? false : _ref6$isSuitableForJu,
    _ref6$slug = _ref6.slug,
    slug = _ref6$slug === void 0 ? 'divers' : _ref6$slug;
  return {
    name: name,
    slug: slug,
    items: getPricingsItemsWithIds(getFilteredVariousPricingsItems(pieceSlug, categorySlug), categorySlug, pieceSlug, type, minIndex, isSuitableForJunior)
  };
};
var getVariousPricingsItemsForCreation = exports.getVariousPricingsItemsForCreation = function getVariousPricingsItemsForCreation(_ref7) {
  var slug = _ref7.slug,
    _ref7$type = _ref7.type,
    type = _ref7$type === void 0 ? 'SIMPLE' : _ref7$type,
    autoComplexFactor = _ref7.autoComplexFactor,
    _ref7$isClosingsOnly = _ref7.isClosingsOnly,
    isClosingsOnly = _ref7$isClosingsOnly === void 0 ? false : _ref7$isClosingsOnly,
    _ref7$categorySlug = _ref7.categorySlug,
    categorySlug = _ref7$categorySlug === void 0 ? 'divers_crea' : _ref7$categorySlug;
  var filteredVariousPricingsItems = getFilteredVariousPricingsItems(slug);
  if (isClosingsOnly) filteredVariousPricingsItems = filteredVariousPricingsItems.filter(function (_ref8) {
    var isClosing = _ref8.isClosing;
    return isClosing;
  });
  var pricingsItems = [];
  filteredVariousPricingsItems.forEach(function (_ref9) {
    var name = _ref9.name,
      prices = _ref9.prices,
      multiple = _ref9.multiple,
      hidden = _ref9.hidden,
      itemPosition = _ref9.itemPosition;
    var item = {
      name: name,
      categorySlug: categorySlug,
      itemPosition: itemPosition
    };
    item.priceForAllTypes = prices[type];
    if (hidden) item.hidden = hidden;
    if (multiple) item.multiple = multiple;
    if (autoComplexFactor) item.autoComplexFactor = autoComplexFactor;
    pricingsItems.push(item);
  });
  return pricingsItems.sort(function (itemA, itemB) {
    if (itemA.itemPosition === undefined || itemB.itemPosition === undefined) {
      return 0;
    }
    return itemA.itemPosition - itemB.itemPosition;
  });
};